let filter = document.getElementById('filter')

if (filter !== null) {
    filter.addEventListener('mouseover', function(e) {
        e.preventDefault()
        this.classList.add('open')
    })

    filter.addEventListener('mouseout', function(e) {
        e.preventDefault()
        this.classList.remove('open')
    })

}
